'use client';

import { c as _c } from "react/compiler-runtime";
import { Divider } from '@algoacademy/design-system/web/layouts/Divider';
import { usePathname } from 'next/navigation';
import { getBazaArticleReadingSegments } from '@/app/baza/_helpers/get-baza-article-reading-segments';
import { ModuleSidebarMobile } from '@/app/baza/(collection)/_components/ModuleSidebar/ModuleSidebarMobile';
import { useCollectionStructure } from '@/app/baza/(collection)/_utils/CollectionStructureContext/CollectionStructureContext';
import { NavbarMobileManageCollectionButton } from './NavbarMobileManageCollectionButton';
type NavbarMobileArticleSidebarSectionProps = {
  isLoggedIn: boolean;
  onNavigate?: () => void;
};
export function NavbarMobileArticleSidebarSection(t0) {
  const $ = _c(6);
  const {
    isLoggedIn,
    onNavigate
  } = t0;
  const pathname = usePathname();
  let t1;
  if ($[0] !== pathname) {
    t1 = getBazaArticleReadingSegments(pathname);
    $[0] = pathname;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const articleReadingSegments = t1;
  if (!articleReadingSegments) {
    return null;
  }
  let t2;
  if ($[2] !== articleReadingSegments.articleSlug || $[3] !== isLoggedIn || $[4] !== onNavigate) {
    t2 = <NavbarMobileArticleSidebarSectionContent isLoggedIn={isLoggedIn} onNavigate={onNavigate} articleSlug={articleReadingSegments.articleSlug} />;
    $[2] = articleReadingSegments.articleSlug;
    $[3] = isLoggedIn;
    $[4] = onNavigate;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
type NavbarMobileArticleSidebarSectionContentProps = {
  isLoggedIn: boolean;
  onNavigate?: () => void;
  articleSlug: string;
};
function NavbarMobileArticleSidebarSectionContent(t0) {
  const $ = _c(8);
  const {
    isLoggedIn,
    onNavigate,
    articleSlug
  } = t0;
  const {
    modules
  } = useCollectionStructure();
  const articleExists = modules.some(module => module.articles.some(article => article.slug === articleSlug));
  if (!articleExists) {
    return null;
  }
  let t1;
  if ($[0] !== onNavigate) {
    t1 = <NavbarMobileManageCollectionButton onNavigate={onNavigate} />;
    $[0] = onNavigate;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== isLoggedIn) {
    t2 = <ModuleSidebarMobile isLoggedIn={isLoggedIn} />;
    $[2] = isLoggedIn;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Divider />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1 || $[6] !== t2) {
    t4 = <div className="space-y-4">{t1}{t2}{t3}</div>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}